import "../../index35.css";
import { jsxs as r, jsx as i } from "react/jsx-runtime";
import { a as j } from "../../type-BFTbooL7.js";
import { _ as l } from "../../cs-piwRuCFZ.js";
import g from "../NumberOutput/index.js";
import S from "../ProgressBar/index.js";
const y = "_key-figure_1owjn_1", I = "_icon-section_1owjn_8", k = "_icon_1owjn_8", x = "_info_1owjn_20", F = "_info-section-without-icon_1owjn_25", b = "_value_1owjn_31", C = "_description_1owjn_36", W = "_with-icon_1owjn_41", o = {
  keyFigure: y,
  iconSection: I,
  icon: k,
  info: x,
  infoSectionWithoutIcon: F,
  value: b,
  description: C,
  withIcon: W
};
function T(m) {
  const {
    className: _,
    children: c,
    contentClassName: d,
    value: u,
    compactValue: p,
    label: s,
    labelClassName: f,
    description: t,
    descriptionClassName: h,
    progress: a,
    progressTitle: v,
    progressDescription: N,
    icon: n,
    info: e,
    suffix: w
  } = m;
  return /* @__PURE__ */ r(
    "div",
    {
      className: l(
        o.keyFigure,
        !!n && o.withIcon,
        _
      ),
      children: [
        n && /* @__PURE__ */ r("div", { className: o.iconSection, children: [
          /* @__PURE__ */ i("div", { className: o.icon, children: n }),
          e && /* @__PURE__ */ i("div", { className: o.infoSection, children: e })
        ] }),
        !n && e && /* @__PURE__ */ i("div", { className: o.infoSectionWithoutIcon, children: e }),
        /* @__PURE__ */ i(
          g,
          {
            className: o.value,
            value: u,
            compact: p,
            suffix: w
          }
        ),
        s && /* @__PURE__ */ i("div", { className: f, children: s }),
        t && /* @__PURE__ */ i("div", { className: l(h, o.description), children: t }),
        j(a) && /* @__PURE__ */ i(
          S,
          {
            title: v,
            value: a,
            totalValue: 100,
            description: N
          }
        ),
        c && /* @__PURE__ */ i("div", { className: d, children: c })
      ]
    }
  );
}
export {
  T as default
};
